import { useEffect, useState } from "react";
import { subscribe } from "../../../../server/requests";

import ErrorMessage from "../../../AlertMessage/ErrorMessage";

export default ({ tariff, setType }) => {

    const [values, setValues] = useState({
        cardNumber: { value: '', max: 16, class: '' },
        day: { value: '', max: 2, class: '' },
        year: { value: '', max: 4, class: '' },
    })
    const [error, setError] = useState('')
    const [successMessage, setSuccessMessage] = useState('')
    const [showErrorMessage, setShowErrorMessage] = useState(false)

    useEffect(() => {
        if (!tariff) setType('')
    }, []);

    const onSubmit = (e) => {

        e.preventDefault()

        if (values.cardNumber.value.length < values.cardNumber.max) {
            setValues({ ...values, cardNumber: { ...values.cardNumber, class: 'error' } })
        } else if (values.day.value.length < values.day.max) {
            setValues({ ...values, day: { ...values.day, class: 'error' } })
        } else if (values.year.value.length < values.year.max) {
            setValues({ ...values, year: { ...values.year, class: 'error' } })
        } else {

            var body = {
                cardExpirationDate: values.year.value + '-' + values.day.value,
                cardNumber: values.cardNumber.value,
                tariff_id: tariff.id
            }

            subscribe(body, res => {
                setError('')
                setSuccessMessage(res)
                setShowErrorMessage(true)
                hide_alert_message()
            }, err => {
                setError(err)
                // setShowErrorMessage(true)
                // setTimeout(() => {
                //     setShowErrorMessage(false)
                // }, 5000);
            })
        }
    }

    const ChangeHandler = (e) => {
        if (!isNaN(e.target.value) && e.target.value.length <= e.target.max) {
            setValues({ ...values, [e.target.name]: { value: e.target.value, max: e.target.max, class: '' } })
        }
    }

    const hide_alert_message = () => {
        setTimeout(() => {
            setShowErrorMessage(false)
        }, 5000);
    }

    return (
        <>
            <ErrorMessage text={successMessage} type={'success'} show={showErrorMessage} />

            <div className="main_pay_field">
                <h2>You will change your tariff to "{tariff.name}" by price {tariff.currency == "USD" ? "$" : tariff.currency}{tariff.price}</h2>
                {/* <input type="text" placeholder="First Name" name={'lastName'} />
            <input type="text" placeholder="Last Name" name={'firstName'} /> */}
                <form action="" onSubmit={onSubmit}>
                    <input type="text" max={16} className={values.cardNumber.class} placeholder="Card Number" name={'cardNumber'} value={values.cardNumber.value} onChange={e => ChangeHandler(e)} />
                    <input type="text" max={2} className={values.day.class} placeholder="MM" name={'day'} value={values.day.value} onChange={e => ChangeHandler(e)} />
                    <input type="text" max={4} className={values.year.class} placeholder="YYYY" name={'year'} value={values.year.value} onChange={e => ChangeHandler(e)} />
                    <button className="card_color">Pay</button>
                </form>
                {!showErrorMessage ? <p className="error_message">{error}</p> : null}
            </div>
        </>
    )
}